export const AES_GCM_DERIVED_ALGORITHM = 'r.aes-256-gcm.derived';
//# sourceMappingURL=derivedEncryption.js.map